<template>
  <div class="terminal-error">
    <pre class="ascii-skull">
{{ skull }}
    </pre>
    <p class="error-msg">{{ $t('error.not_found') }}</p>
    <router-link to="/" class="back-home">{{ $t('error.back_home') }}</router-link>
  </div>
</template>

<script setup>


const skull = `
███████╗██████╗ ██████╗  ██████╗ ██████╗ 
██╔════╝██╔══██╗██╔══██╗██╔═══██╗██╔══██╗
█████╗  ██████╔╝██████╔╝██║   ██║██████╔╝
██╔══╝  ██╔══██╗██╔══██╗██║   ██║██╔══██╗
███████╗██║  ██║██║  ██║╚██████╔╝██║  ██║
╚══════╝╚═╝  ╚═╝╚═╝  ╚═╝ ╚═════╝ ╚═╝  ╚═╝
                                
`
</script>

<style scoped>
.terminal-error {
  color: #00ffcc;
  font-family: 'Fira Code', monospace;
  white-space: pre-wrap;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.ascii-skull {
  align-items: center;
  font-size: 12px;
  line-height: 1.5;
  letter-spacing: 2px;
  animation: glitchSkull 3s infinite;
}

.error-msg {
  font-size: 1.5rem;
  color: #00ffcc;
  animation: flickerText 1.5s infinite alternate;
}

.back-home {
  padding: 10px 20px;
  border: 2px solid #00ffcc;
  text-decoration: none;
  color: #00ffcc;
  font-weight: bold;
  transition: all 0.3s ease;
}
.back-home:hover {
  color: #fff !important;
  background-color: #00ffcc !important;
  border-color: #00ffcc;
  transform: translateY(-2px);
}

@keyframes flicker {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.92;
  }
  75% {
    opacity: 0.8;
  }
}

@keyframes glitchSkull {
  0% { text-shadow: 2px 2px #0ff; }
  50% { text-shadow: -2px -2px #0ff; }
  100% { text-shadow: 1px -1px #0ff; }
}

@keyframes flickerText {
  0% { opacity: 0.8; }
  100% { opacity: 1; }
}
</style>
